import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { APPROVAL_SURGE_COMPAIGN, APPROVAL_SURGE_COMPAIGN_SUCCESS, APPROVAL_SURGE_COMPAIGN_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* approveSurgeCompaign({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { compaignId, approvalType } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-campaigns/${compaignId}/${approvalType}`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: APPROVAL_SURGE_COMPAIGN_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: APPROVAL_SURGE_COMPAIGN_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: APPROVAL_SURGE_COMPAIGN_ERROR, payload: error });
  }
}

export function* watchapproveSurgeCompaign() {
  yield takeEvery(APPROVAL_SURGE_COMPAIGN, approveSurgeCompaign);
}

function* approveSurgeCompaignSaga() {
  yield all([fork(watchapproveSurgeCompaign)]);
}

export default approveSurgeCompaignSaga;
